import * as THREE from "three";

export default class HoverObserver {

    constructor() {
        this._raycaster = new THREE.Raycaster();
        this._pointer = new THREE.Vector2();

        this._objects = new Set();

        this._listeners = new Set();

        this._handlePointer = this._handlePointer.bind(this);
    }

    get root() {
        return this._root;
    }

    observe(root) {
        this._root = root;
        root.addEventListener("pointerdown", this._handlePointer);
        root.addEventListener("pointermove", this._handlePointer);
        root.addEventListener("pointerup", this._handlePointer);
    }

    unobserve() {
        this._root.removeEventListener("pointerup", this._handlePointer);
        this._root.removeEventListener("pointermove", this._handlePointer);
        this._root.removeEventListener("pointerdown", this._handlePointer);
    }

    addObject(object) {
        this._objects.add(object);
    }

    removeObject(object) {
        this._objects.delete(object);
    }

    addListener(callback) {
        this._listeners.add(callback);
    }

    removeListener(callback) {
        this._listeners.delete(callback);
    }

    update(camera) {
        this._raycaster.setFromCamera(this._pointer, camera);
        const intersects = this._raycaster.intersectObjects(Array.from(this._objects), false);
        const closest = intersects.length ? intersects[0].object : null;

        this._listeners.forEach(callback => callback(closest));
    }

    _handlePointer(ev) {
        const root = this._root;

        const { left: rootX, top: rootY } = root.getBoundingClientRect();

        this._pointer.set(
            ((ev.clientX - rootX) / root.clientWidth) * 2 - 1,
            - ((ev.clientY - rootY) / root.clientHeight) * 2 + 1,
        );
    }

}
